import { render } from "./EditIcon.vue?vue&type=template&id=4c350fe3&scoped=true"
const script = {}

import "./EditIcon.vue?vue&type=style&index=0&id=4c350fe3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c350fe3"]])

export default __exports__